module.exports = __webpack_public_path__ + "img/arh_12.67991495.jpg";